import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { ExternalLink, Radio } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, publicShopUrl } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { PageHeader } from "../../components/PageHeader";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";
import { Button } from "../../components/ui/button";

const LiveCard = ({ shop, setShop }) => {
  const toggle = async (v) => {
    try {
      const { data } = await api.put("/shop/live", { is_live: v });
      setShop(data.shop);
      toast.success(v ? "Toko publik LIVE" : "Toko publik disembunyikan");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 fade-up" data-testid="live-shop-card">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="flex items-center gap-2">
            <Radio className={`h-4 w-4 ${shop.is_live ? "text-emerald-500 animate-pulse" : "text-slate-400"}`} />
            <h3 className="font-bold" data-testid="live-shop-status">{shop.is_live ? "Toko publik LIVE" : "Toko publik OFFLINE"}</h3>
          </div>
          <p className="mt-1 text-sm text-slate-600">Matikan untuk menyembunyikan toko publik dari pengunjung.</p>
        </div>
        <Switch checked={!!shop.is_live} onCheckedChange={toggle} data-testid="live-shop-toggle" />
      </div>
      <Button asChild variant="outline" className="mt-4 rounded-xl w-full">
        <a href={publicShopUrl(shop.slug)} target="_blank" rel="noreferrer" data-testid="live-shop-open-link">
          <ExternalLink className="h-4 w-4 mr-1" />{window.location.host}/{shop.slug}
        </a>
      </Button>
    </div>
  );
};

export default function Account() {
  const { user, setUser } = useAuth();
  const { shop, setShop } = useOutletContext();
  const [form, setForm] = useState({ name: user.name || "", email: user.email || "", whatsapp: user.whatsapp || "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/account", form);
      setUser(data);
      toast.success("Akun diperbarui");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <PageHeader title="Pengaturan Akun" subtitle="Data profil dan status toko publik." />
      <div className="grid lg:grid-cols-3 gap-6">
        <form onSubmit={save} className="lg:col-span-2 rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 space-y-4 fade-up" data-testid="account-form">
          <div className="space-y-1.5"><Label>Nama profil</Label><Input required value={form.name} onChange={set("name")} data-testid="account-name-input" /></div>
          <div className="space-y-1.5"><Label>Email</Label><Input required type="email" value={form.email} onChange={set("email")} data-testid="account-email-input" /></div>
          <div className="space-y-1.5"><Label>Nomor WhatsApp</Label><Input value={form.whatsapp} onChange={set("whatsapp")} placeholder="08xxxxxxxxxx" data-testid="account-whatsapp-input" /></div>
          <Button type="submit" disabled={busy} className="rounded-xl" data-testid="account-save-button">{busy ? "Menyimpan..." : "Simpan"}</Button>
        </form>
        {user.role === "toko" && shop && <LiveCard shop={shop} setShop={setShop} />}
      </div>
    </div>
  );
}
